import ajax from '../utils/axios'

// 用户列表
export const GetUserList = (params) => ajax.get(`/index/user/get_user_list?limit=${params.limit}&page=${params.page}`)

// 添加用户
export const PostUserAdd = (params) => ajax.post('/index/user/add', params)

// 修改用户
export const PostUserEdit = (params) => ajax.post('/index/user/edit', params)

// 用户界面的组织列表
export const GetFirmList = (params) => ajax.get('/index/user/get_firm_list', params)

// 冻结用户
export const PostUserFreeze = (params) => ajax.post('/index/user/freeze', params)
